import React, { Component } from "react";
import PropTypes from "prop-types";

import { getNotification, UpdateNotification } from "../Actions/CommonAction";
import { token, roleid } from "../Actions/AuthAction";
import ReactPaginate from "react-paginate";
import { showLoader, hideLoader } from "../../utils";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Loader from "../Common/Loader";
import { setOptions } from "../../utils";
import { classNames } from "classnames";
import CONFIG from "../../config";

export default class NotificationList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: token(),
      data: [],
      totalCount: 0,
      showModel: false,
      limit: 9,
      currentPage: 0,
      readstatus: "",
      loading: true,
      currentPage: 0,
    };
  }

  componentDidMount() {
    const { readstatus, currentPage, token } = this.state;
    const model = {
      loginusertoken: token,
      page: currentPage + 1,
      readstatus: readstatus,
    };

    this.setState({
      currentPage: 0,
    });

    this.loadList(model);
  }

  loadList = (model) => {
    this.setState({
      loading: true,
    });
    getNotification(model)
      .then((res) => {
        hideLoader(this);
        this.setState({
          totaldata: res.totaldata,
          data: res.data,
          originalData: res.data,
          totalCount: res.totaldata,
          loading: false,
        });
      })
      .catch((e) => hideLoader(this));
  };

  //   OnCheckboxStatusChange = (e, code) => {
  //     Swal.fire({
  //       title: `Are you sure, you want to mark this candidate as ${
  //         e.target.checked ? "InActive" : "Active"
  //       } ?`,
  //       text: "",
  //       icon: "",
  //       buttons: true,
  //       dangerMode: false,
  //     }).then((willDelete) => {
  //       if (willDelete) {
  //         const { data } = this.state;
  //         data.map((item) => {
  //           if (item.user.id === code) {
  //             item.user.status = e.target.checked;
  //           }
  //         });

  //         console.log(e.target.checked);
  //         console.log(code);
  //         this.setState({ data }, () => {
  //           changeStatus({
  //             loginusertoken: token(),
  //             userid: code,
  //             status: !e.target.checked,
  //           }).then((res) => {
  //             console.log("status updated");
  //             Swal.fire("Success", res.message, "success");
  //           });
  //         });
  //       }
  //     });
  //   };

  handlePageClick = (data) => {
    let selected = data.selected;

    this.setState(
      {
        currentPage: selected,
      },
      () => {
        const {
          readstatus,

          token,
        } = this.state;
        const model = {
          loginusertoken: token,
          page: selected + 1,
          readstatus: readstatus,
        };
        this.loadList(model);
      }
    );
  };

  filterdata = (data) => {
    const { readstatus, token, currentPage } = this.state;
    const model = {
      loginusertoken: token,
      page: currentPage + 1,
      readstatus: data,
    };
    this.loadList(model);
  };

  //   searchdata = (data) => {
  //     const {
  //       search,
  //       status,
  //       city,
  //       state,
  //       limit,
  //       token,
  //       skill,
  //       instid,
  //       uniid,
  //       currentPage,
  //     } = this.state;
  //     const model = {
  //       key: token,
  //       page: currentPage + 1,
  //       search: data,
  //       status: status,
  //       state: state,
  //       city: city,
  //       skill: skill,
  //       instid: instid,
  //       uniid: uniid,
  //       limit: limit,
  //     };
  //     this.loadList(model);
  //   };

  //   onSearchValue = (e) => {
  //     this.setState({
  //       search: e.target.value,
  //     });
  //   };

  clickdata = (e) => {
    UpdateNotification({
      loginusertoken: token(),
      noteid: e,
      readstatus: 2,
    }).then((res) => {
      const { token, currentPage } = this.state;
      const model = {
        loginusertoken: token,
        page: currentPage + 1,
        readstatus: 2,
      };

      this.loadList(model);
    });

    //this.setState({currentPage : 0})
  };

  render() {
    const { data, totalCount, limit, loading } = this.state;
    return (
      <>
        {loading && <Loader />}
        <div className="row mb-4">
          <div className="col-md-12">
            <h4 className="table_heading position-relative">
              NOTIFICATION LIST
            </h4>
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <h6 className="text-black font-weight-bold">
            <span>{`${
              this.state.currentPage
                ? this.state.currentPage * this.state.limit + 1
                : 1
            }-${
              data.length < limit
                ? totalCount
                : (this.state.currentPage + 1) * this.state.limit
            }`}</span>{" "}
            <span>/ {this.state.totalCount} Search Results</span>
          </h6>
        </div>
        <div className="row">
          <div className="col-md-3 order-sm-12">
            <div className="card formcard p-2 mb-3">
              <p className="text-black font-weight-bold table_heading position-relative">
                Filter
              </p>
              <form className="form-group">
                <div className="form-group col-md-12">
                  <label className="mb-1" for="inputEmailAddress">
                    Drive Type
                  </label>
                  <select
                    onChange={(e) => this.filterdata(e.target.value)}
                    className="form-control"
                  >
                    <option value="">All</option>
                    <option value="2">Read</option>
                    <option value="1">Unread</option>
                  </select>
                </div>
              </form>
            </div>
          </div>
          <div className="col-md-9 order-sm-1">
            <div className="row px-2">
              {this.state.data
                ? this.state.data.map((item, i) => (
                    <div
                      onClick={(e) => this.clickdata(item.id)}
                      className={
                        item.readstatus == 1
                          ? "card mb-3 w-100 bg-light unreadpointer"
                          : "card mb-3 w-100 bg-white"
                      }
                    >
                      <div className="card-body position-relative">
                        <span
                          className={
                            item.readstatus == 1
                              ? "badge badge-pill badge-warning notificationbadge"
                              : "badge badge-pill badge-success notificationbadge"
                          }
                        >
                          {item.readstatus == 1 ? "Unread" : "Read"}
                        </span>
                        <span className="unreadnotification">
                          {item.notificationtitle}
                        </span>
                        <p>
                          {item.description} (
                          <strong>{item.createddate}</strong>)
                        </p>
                      </div>
                    </div>
                  ))
                : null}
            </div>
            <div className="d-flex justify-content-center">
              <div class="pagination">
                <ReactPaginate
                  previousLabel={
                    <i
                      className="fa fa-angle-double-left"
                      aria-hidden="true"
                    ></i>
                  }
                  nextLabel={
                    <i
                      className="fa fa-angle-double-right"
                      aria-hidden="true"
                    ></i>
                  }
                  pageCount={
                    this.state.totalCount % this.state.limit === 0
                      ? parseInt(this.state.totalCount / this.state.limit)
                      : parseInt(this.state.totalCount / this.state.limit) + 1
                  }
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
